module.exports = __webpack_public_path__ + "img/Udara360-logo.1ddaab6e.png";